import React, { useState, useCallback } from "react";
import ContentLoader from "react-content-loader";

const NakiStoreFeaturedSectionLoaderTemplate = (props) => {
    const { gridNum = 9 } = props;
    const [loaderWidth, setLoaderWidth] = useState(0);
    const gridList = [];

    const ref = useCallback((node) => {
        if (node !== null) {
            setLoaderWidth(node.getBoundingClientRect().width - 32);
        }
    }, []);

    const cardHeight = 315;

    for (let i = 0; i < gridNum; i++) {
        gridList.push(
            <div className="c-card--lrg c-card--primary" key={i} ref={ref}>
                <ContentLoader
                    speed={2}
                    width={loaderWidth}
                    height={cardHeight}
                    viewBox={`0 0 ${loaderWidth} ${cardHeight}`}
                    backgroundColor="#262729"
                    foregroundColor="#2b2b2b"
                    {...props}
                >
                    <rect x="0" y="0" rx="6" ry="6" width="100%" height="237" />
                    <rect x="0" y="250" rx="6" ry="6" width="100%" height="20" />
                    <rect x="0" y="280" rx="6" ry="6" width="49%" height="35" />
                    <rect x="51%" y="280" rx="6" ry="6" width="49%" height="35" />
                </ContentLoader>
            </div>
        );
    }

    return <div className="c-grid c-grid--store-list u-gap--sml">{gridList}</div>;
};

export default NakiStoreFeaturedSectionLoaderTemplate;
